// Stateless bridge to the owning bundles: never import their registries into a second bundle.
export function hydrateSubtree(root: HTMLElement): void {
    const page = window as unknown as Record<string, ((root: HTMLElement) => void) | undefined>;
    for (const name of [
        'ftMountEncounterDisplays', 'ftMountParsedText', 'ftMountParseTextTables',
        'ftMountInventoryTiles', 'ftMountRuneIcons', 'ftMountIcons', 'ftMountThumbnails',
        'ftMountStatusEffects', 'initializeTomSelect', 'syncUserChoiceTomSelectsFromNative',
    ]) {
        try { page[name]?.(root); }
        catch (error) { console.warn(`${name} failed`, error); }
    }
    const Tooltip = (window as unknown as {
        bootstrap?: { Tooltip?: { getOrCreateInstance: (el: Element, options: object) => unknown } };
    }).bootstrap?.Tooltip;
    root.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
        Tooltip?.getOrCreateInstance(el, { boundary: 'window', trigger: 'hover focus' });
    });
}
